import React, { useState } from "react";
import "./InstallerPackPhotos.css";

function InstallerPackPhotos({ onSitePhotos }) {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);

  const handleSelectedImage = (e) => {
    setSelectedImage(e.target.src.replace(/[^a-z]/g, ""));
    setSelectedImageUrl(e.target.src);
  };
  const showDefaultImages = onSitePhotos?.map((photo) => (
    <div className="col-4" key={photo}>
      <div
        type="button"
        data-toggle="modal"
        data-target={`#${photo.replace(/[^a-z]/g, "")}`}
        onClick={handleSelectedImage}
        className="installerPackPhotoContainer m-3"
      >
        <img src={photo} alt="site image" className="installerPackPhoto" />
      </div>
    </div>
  ));

  return (
    <div>
      <div className="row">{showDefaultImages}</div>
      <div
        className="modal fade"
        id={selectedImage}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" data-dismiss="modal">
            <div className="modal-body">
              <img src={selectedImageUrl} alt={selectedImage} width="100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InstallerPackPhotos;
